import _ from 'lodash';

import { initialSupplierDetailAttributes } from '../components/user-management/supplier-details/data';

const initialState = {
  supplierDetailsList: {},
  supplierAttributes: _.cloneDeep(initialSupplierDetailAttributes),
  approvedBuyersList: [],
  companyDetailsBySearchTerm: [],
  companyRegistrationDetails: {},
  csmTenants: null,
  sellersList: []
};

const UserServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SUPPLIER_LIST':
      return {
        ...state,
        supplierDetailsList: action.payload
      };
    case 'UPDATE_SUPPLIER_ATTRIBUTES':
      return { ...state, supplierAttributes: action.payload };
    case 'APPROVED_BUYERS_LIST':
      return {
        ...state,
        approvedBuyersList: action.payload
      };
    case 'COMPANY_DETAILS_BY_SEARCH_TERM':
      return {
        ...state,
        companyDetailsBySearchTerm: action.payload
      };
    case 'COMPANY_REGISTRATION_DETAILS':
      return {
        ...state,
        companyRegistrationDetails: action.payload
      };
    case 'CSM_TENANTS':
      return {
        ...state,
        csmTenants: action.payload
      };
    case 'GET_SELLERS_LIST':
      return {
        ...state,
        sellersList: action.payload
      };
    default:
      return state;
  }
};

export default UserServiceReducer;
